<template>
  <el-form ref="formValidate"
           :model="params"
           :rules="rules"
           label-width="180px"
           label-position="right">
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.account')"
                      prop="loginName">
          <el-input v-model="params.loginName"
                    :placeholder="$t('user.inputAccount')"
                    :disabled="isUpdate">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('user.userName')"
                      prop="name">
          <el-input v-model="params.name"
                    :placeholder="$t('user.inputName')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.password')"
                      prop="password"
                      v-if="!isUpdate">
          <el-input type="password"
                    v-model="params.password"
                    :placeholder="$t('user.inputPwd')">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('user.confirmedPwd')"
                      prop="secondPwd"
                      v-if="!isUpdate">
          <el-input type="password"
                    v-model="params.secondPwd"
                    :placeholder="$t('user.input2ndPwd')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.email')"
                      prop="email">
          <el-input v-model="params.email"
                    :placeholder="$t('user.inputEmail')"
                  @input="op"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('user.phone')"
                      prop="phone">
          <el-input v-model="params.phone"
                    :placeholder="$t('user.inputPhone')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.sex')"
                      prop="sex">
          <zk-dictionary-select type="sex"
                                v-model="params.sex"
                                clearable
                                :placeholder="$t('common.select')"
                                style="width:100%">
          </zk-dictionary-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('user.nickName')"
                      prop="nickName">
          <el-input v-model="params.nickName"
                    :placeholder="$t('user.inputNickName')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.status')"
                      prop="status">
          <zk-dictionary-select type="status"
                                v-model="params.status"
                                :placeholder="$t('common.select')"
                                style="width:100%"></zk-dictionary-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item :label="$t('user.department')"
                      prop="deptName">
          <el-tree ref="deptTree"
                   :data="treeData"
                   :props="defaultProps"
                   node-key="id"
                   show-checkbox
                   :default-expanded-keys="deptArr"></el-tree>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { add, update } from '../../../services/user.js'
import { validatorPhoneRule, validatorEmailRule } from '@/utils/validatorRule.js'
export default {
  name: 'zk-user-save-or-update',
  props: ['isUpdate', 'treeData', 'form', 'deptArr', 'row'],
  data () {
    let checkRepasswd = (rule, value, callback) => {
      if (!(value + '')) {
        return callback(new Error(this.$t('user.input2ndPwd')))
      } else if (value !== this.params.password) {
        return callback(new Error(this.$t('user.pwdInconsistent')))
      } else {
        callback()
      }
    }
    let checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('user.selectStatus')))
      } else {
        callback()
      }
    }
    let checkPhone = (rules, value, callback) => {
      if (this.sourceData.phone && value.substr(3, 5) === '*****') {
        if (value !== this.phoneFormat(this.sourceData.phone)) {
          return callback(new Error(window.vm.$t('common.phoneValid')))
        }
      }
      callback()
    }
    let checkEmail = (rules, value, callback) => {
      if (this.sourceData.email && (value.substr(2, 3) === '***' || value.substr(1, 3) === '***')) {
        if (value !== this.emailFormat(this.sourceData.email)) {
          return callback(new Error(window.vm.$t('common.emailValid')))
        }
      }
      callback()
    }
    let rules = {
      loginName: this.validatorInputEmptyRule(true, 30),
      name: this.validatorInputEmptyRule(false, 100),
      password: this.validatorPasswordRule(true),
      secondPwd: [
        { required: true, validator: checkRepasswd, trigger: 'blur' }
      ],
      status: [{ required: true, validator: checkStatus, trigger: 'blur' }],
      email: validatorEmailRule(false, checkEmail),
      phone: validatorPhoneRule(false, checkPhone)
    }
    let defaultProps = {
      children: 'children',
      label: 'name'
    }
    return {
      params: JSON.parse(JSON.stringify(this.form || {})),
      rules,
      defaultProps,
      checkedArr: [],
      email: '',
      sourceData: {
        phone: '',
        email: ''
      }
    }
  },
  methods: {
    op (val) {
      this.$forceUpdate()
    },
    save () {
      let _self = this
      let arr = this.$refs.deptTree.getCheckedKeys(true)
      _self.params.deptArr = arr
      return new Promise((resolve, reject) => {
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            if (!_self.isUpdate) {
              resolve(add(_self.params))
            } else {
              let parms = {
                ..._self.params
              }
              if (_self.params.email === _self.emailFormat(_self.sourceData.email)) {
                parms.email = _self.sourceData.email
              } else {
                parms.email = _self.params.email
              }
              if (_self.params.phone === _self.phoneFormat(_self.sourceData.phone)) {
                parms.phone = _self.sourceData.phone
              } else {
                parms.phone = _self.params.phone
              }
              resolve(update(parms))
            }
          } else {
            reject(valid)
          }
        })
      })
    },
    resetFields () {
      this.$refs.formValidate.resetFields()
    }
  },
  watch: {
    form: {
      handler (newValue, oldValue) {
        if (JSON.stringify(newValue || oldValue)) {
          this.params = JSON.parse(JSON.stringify(newValue || oldValue))
          this.sourceData.phone = this.params.phone
          this.sourceData.email = this.params.email
          this.$set(this.params, 'email', this.emailFormat(this.params.email)) // input 无法输入   :手动修改了input值，视图无法更新
          this.$set(this.params, 'phone', this.phoneFormat(this.params.phone))
        }
      },
      immediate: true
    },
    deptArr (val) {
      this.$refs.deptTree.setCheckedKeys(val)
    }
  }
}
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/userSaveOrUpdate/src/main.vue